import React, { useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Breadcrumbs,
} from "@mui/material";
import {
  AccountBalance,
  Bento,
  Payments,
  PivotTableChart,
  Pix,
  Sell,
} from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import { SalaryComponent } from "./Configuration/SalaryComponent";
import { SalaryTemplate } from "./Configuration/SalaryTemplate";
import { SalaryComponentGroupView } from "./UserAssignment/SalaryComponent/GroupView";
import { SalaryTemplateGroupView } from "./UserAssignment/SalaryTemplate/GroupView";
import { themes, sideBarWidth, theme } from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import { FilterProvider } from "pages/FilterContext";
import { setFilterApi } from "services/Redux/userManagament";
import { SalaryRevise } from "./Configuration/SalaryRevise";
import { SalaryTable } from "./UserAssignment/SalaryTable";
import { SalaryReviseProvider } from "./Configuration/SalaryRevise/SalaryReviseContext";
export const SalaryConfiguration = () => {
  const [salaryConfigItem, setSalaryConfigItem] = useState("Salary Component");
  const shiftSidebarOpen = true;
  const { domain, userScreenAccess, userDetails } = useSelector(
    (state) => state.tokenReducer,
  );
  const dispatch = useDispatch();

  const shiftModule = userScreenAccess?.module_details.find(
    (mod) => mod.module_name === "Salary Configuration",
  );

  const subModuleId = shiftModule?.submodules?.find(
    (sub) => sub.sub_module_name === salaryConfigItem,
  )?.sub_module_id;

  const menuItems = [
    {
      type: "title",
      title: "Configuration",
    },
    {
      type: "item",
      title: "Salary Component",
      key: "Salary Component",
      subtitle: "Define pay elements",
      icon: <Bento />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Salary Template",
      key: "Salary Template",
      subtitle: "Set salary formats",
      icon: <Sell />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Salary Revision",
      key: "Salary Revision",
      subtitle: "Set salary Revisions",
      icon: <Pix />,
      color: "#6c757d",
    },
    {
      type: "title",
      title: "User Assignment",
    },

    {
      type: "item",
      title: "Salary Component",
      key: "Group Salary Component",
      groupKey: "Group Salary Component",
      subtitle: "Define pay elements",
      icon: <AccountBalance />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Salary Template",
      key: "Group Salary Template",
      groupKey: "Group Salary Template",
      subtitle: "Set employees",
      icon: <Payments />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Salary Table",
      key: "Salary Table",
      subtitle: "Set salary table",
      icon: <PivotTableChart />,
      color: "#6c757d",
    },
  ];

  const handleShiftItemClick = (itemTitle) => {
    if (salaryConfigItem === itemTitle) return;
    setSalaryConfigItem(itemTitle);
    dispatch(setFilterApi(true));
  };

  const renderMainContent = () => {
    switch (salaryConfigItem) {
      case "Salary Component":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryComponent setSalaryConfigItem={setSalaryConfigItem} />
          </FilterProvider>
        );

      case "Salary Template":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryTemplate setSalaryConfigItem={setSalaryConfigItem} />
          </FilterProvider>
        );

      case "Group Salary Component":
      case "Employee Salary Component":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryComponentGroupView
              setSalaryConfigItem={setSalaryConfigItem}
            />
          </FilterProvider>
        );

      case "Group Salary Template":
      case "Employee Salary Template":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryTemplateGroupView
              setSalaryConfigItem={setSalaryConfigItem}
            />
          </FilterProvider>
        );
      case "Salary Revision":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryReviseProvider>
              <SalaryRevise />
            </SalaryReviseProvider>
          </FilterProvider>
        );

      case "Salary Table":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryReviseProvider>
              <SalaryTable />
            </SalaryReviseProvider>
          </FilterProvider>
        );

      default:
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <SalaryComponent setSalaryConfigItem={setSalaryConfigItem} />
          </FilterProvider>
        );
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          height: "94.5vh",
          backgroundColor: themes?.whiteColor,
        }}
      >
        <Box
          sx={{
            width: shiftSidebarOpen ? sideBarWidth : 0,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            flexShrink: 0,
            mt: "10px",
            backgroundColor: themes?.whiteColor,
            borderRight: "1px solid #f5f5fd",
          }}
        >
          <List sx={{ p: 2 }}>
            {menuItems.map((item, index) =>
              item.type === "title" ? (
                <Typography
                  key={`title-${index}`}
                  variant="subtitle"
                  sx={{ fontWeight: 700, color: "#00D4AA", mt: 2, mb: 2 }}
                >
                  {item.title}
                </Typography>
              ) : (
                <ListItem key={item.title} disablePadding sx={{ mb: 1, mt: 1 }}>
                  <ListItemButton
                    onClick={() => handleShiftItemClick(item.key)}
                    sx={{
                      backgroundColor:
                        salaryConfigItem === (item.key ?? item.groupKey)
                          ? "#f0f8ff"
                          : "transparent",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "38px",
                        color:
                          salaryConfigItem === item.key
                            ? "#00D4AA"
                            : item.color,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {item.subtitle}
                      </Typography>
                    </Box>
                  </ListItemButton>
                </ListItem>
              ),
            )}
          </List>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            minWidth: 0,
            backgroundColor: "#f5f5fd",
            transition: "all 0.3s ease",
          }}
        >
          {shiftSidebarOpen && (
            <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
              <Typography>HR Zone</Typography>
              <Typography>Salary</Typography>
              <Typography color={themes?.blueColor}>
                {salaryConfigItem}
              </Typography>
            </Breadcrumbs>
          )}

          {renderMainContent()}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
